module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Created at":"Erstellt am","Category":"Kategorie","Page Type":"Seitentyp","Everybody":"Jedem","Members":"Mitgliedern","Guests":"Gästen","Accessible by":"Zugänglich von","Tags":"Tags","Add tag":"Tag hinzufügen"}}')
  delete Component.options._Ctor
}
